import styled from 'styled-components'

export const FilteredSearchRow = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    margin: 0;

    .filteredSearch-input {
        border-radius: 3px;
        border: 1px solid var(--gray-400);
        width: 100%;
        cursor: text;

        i {
            color: var(--gray-600);
            padding: 8px;
            cursor: pointer;
            z-index: 1;
        }

        input {
            border: none;
            color: var(--gray-1000);
            padding: 8px;
            width: calc(100% - 28px);
            border-radius: 3px;
            background: var(--gray-0);
        }
    }

    .filteredSearch-filter {
        height: 36px;

        i.custom-filter {
            position: absolute;
            top: 13px;
            z-index: 1;
            padding-left: 8px;
            padding-right: 4px;
            color: var(--blue-500);
        }

        .live-dropdown-button {
            height: 36px;
            padding-left: 24px;
            border-radius: 3px;
            background: var(--gray-0);
            border-color: var(--gray-400);
        }

        ul {
            z-index: 1;
        }
    }
`
